export function getStringPlaceholder(name) {
    return '[[ ' + name.toUpperCase().replaceAll('-', '_') + ' ]]';
}
export function getRefPlaceholder(name) {
    return '[[ REF_' + name.toUpperCase().replaceAll('-', '_') + ' ]]';
}
export function getBooleanPlaceholder(name) {
    return '[[ BOOLEAN_' + name.toUpperCase().replaceAll('-', '_') + ' ]]';
}
/**
 * Simply return the value of the const object when instantiating a const.
 * @param detail The detail from the object to instantiate
 * @returns Either the value or the object described by the 'const' property.
 */
export function getConstValue(detail) {
    return detail.const;
}
export function getDefaultValue(detail) {
    return detail.default;
}
export function getPropertyValue(keyName, detail) {
    // if const, default and type are defined, prefer const
    if (detail.const) {
        return detail.const;
    }
    // if default and type are defined, prefer default
    if (detail.default) {
        return detail.default;
    }
    if (detail.type) {
        const propertyType = detail.type;
        if (propertyType === 'string') {
            return getStringPlaceholder(keyName);
        }
        if (propertyType === 'boolean') {
            return getBooleanPlaceholder(keyName);
        }
        if (propertyType === 'integer' || propertyType === 'number') {
            return -1;
        }
        if (propertyType === 'array') {
            // special case: we always want to instantiate interfaces, even if not required, but not to output [ {{ INTERFACES }} ] in this case.
            if (keyName === 'interfaces') {
                return [];
            }
            return [
                getStringPlaceholder(keyName)
            ];
        }
    }
    if (detail.$ref) {
        return getRefPlaceholder(keyName);
    }
}
export function getEnumPlaceholder(ref) {
    // The pattern matches the trailing segment of any string (including the empty
    // string), so exec never returns null here.
    const refName = /[^/#]*$/.exec(ref)[0];
    const refPlaceholder = refName.toUpperCase().replaceAll('-', '_');
    return `[[ ENUM_${refPlaceholder} ]]`;
}
//# sourceMappingURL=property.js.map